import "../css/users.css";

import React from "react";
import Breadcrumb from "../components/breadcrumb";
import ModalForm from "../components/modalForm";
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Gam = () => {  

    let breadcrumbItens = [
        {
            text: "Home",
            route: "/"
        },
        {
            text: "GAM",
            route: "#"
        }
    ];

    let inputs = [
            {              
                type: "text",
                name: "name",
                label: "Nome",
                isRequired: true
            },
            {
                type: "text",
                name: "description",
                label: "Descrição",
                isRequired: false
            },
            {
                type: "text",
                name: "redirect_uri",
                label: "Redirect URI",
                isRequired: true
            },
            {
                type: "text",
                name: "client_id",
                label: "Client ID",
                isRequired: true
            },
            {
                type: "text",
                name: "client_secret",
                label: "Client secret",
                isRequired: true
            },
            {
                type: "text",
                name: "scope",
                label: "Scope",
                isRequired: true
            }     
    ];

    return (
        <div className="container">
            <ModalForm input={inputs} action="save-gam" elemId="gamModal" isEdit={false} title="GAM" />
            <ModalForm input={inputs} action="update-gam" elemId="editGamModal" isEdit={true} title="GAM" />

            <div className="defaultContainer">
               
                <div className="row">
                    <div className="col-12">
                        <h1 className="h1">GAM
                            <button type="button" className="btn btn-sm btn-add" data-bs-toggle="modal" data-bs-target="#gamModal">
                                <span className="material-symbols-outlined transition">add_box</span>
                            </button>
                        </h1>
                        <Breadcrumb links={breadcrumbItens} />
                    </div>
                </div>
                <br />
                
                <div className="row">
                    <div className="col-12">
                        <table id="dtGam" className="dataTables cell-border table table-bordered table-striped" style={{width:"100%"}}>
                            <thead>
                                <tr className="thead-dark">
                                    <th>Nome</th>
                                    <th>Descrição</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody></tbody>
                            <tfoot></tfoot>
                        </table>    
                    </div>
                </div> 

            </div>
            <HelmetProvider>
                <Helmet>
                    <script src="./js/checkPermissions.js" type="text/javascript"></script>    
                    <script src="./js/datatables/gam.js" type="text/javascript"></script>
                </Helmet>
            </HelmetProvider>  
        </div>
    );
}

export default Gam;